export const imageUploadModalTranslationEN = {
  ImageUploadModal: {
    title: 'Image Maintenance',
    close: 'Close',
    current_image: 'Current Image',
    re_upload: 'ReUpload Image',
    file_selection: 'Select File',
    reflect: 'Reflect',
    upload_confirmation: 'Upload confirmation',
  },
};
